import { useNavigate } from 'react-router-dom';
import { RequestOtpForm } from '../components/request-otp-form';
import { useRequestOtp } from '../api/request-otp';
import { paths } from '@/config/paths';
import { useQueryParams } from '@/hooks/shared/use-query-params';

export function RequestOtp() {
  const navigate = useNavigate();
  const redirect = useQueryParams().getQueryParamByKey('redirect');
  const mutation = useRequestOtp({
    mutationConfig: {
      onSuccess: ({ authenticationId }) => navigate(paths.auth.verify.getHref(authenticationId, redirect)),
    },
  });

  return (
    <div className="space-y-4 max-w-sm mx-auto px-4">
      <h2 className="text-xl font-semibold">Välkommen tillbaka!</h2>
      <p>Ange din e-post så skickar vi en verifieringskod till dig.</p>
      <RequestOtpForm onSubmit={(data) => mutation.mutate({ data })} />
    </div>
  );
}
